<template>
  <nav class="navbar navbar-expand-lg layui-bg-black">
    <div class="container-fluid con">
      <a
        class="navbar-brand"
        href="#"
      ></a>
      <button
        type="button"
        class="navbar-toggler navbar-toggler-right"
        :class="{toggled: $sidebar.showSidebar}"
        aria-controls="navigation-index"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="toggleSidebar"
      >
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse">
        <el-row style="width:100%">
          <el-col :span="24">
            <el-col :span="11">
              <el-menu
                :default-active="$route.path"
                class="el-menu-demo"
                mode="horizontal"
                background-color="#393D49"
                text-color="#fff"
                active-text-color="#ffd04b"
                router
              >
                <el-menu-item index="/home/HomePage">首页</el-menu-item>
                <!-- <el-menu-item  index="/admin/Pishu" >皮书会议</el-menu-item> -->
                <!-- v-show="team" -->
                <el-menu-item
                  index="/admin/MyMeeting"
                  class="ad"
                >会议管理</el-menu-item>
                <!-- <el-menu-item index="/omanag/Olist">机构设置</el-menu-item> -->
                <!-- <el-menu-item index="/dataStatistics">数据统计</el-menu-item> -->
                <!-- <el-menu-item index="/Notice">通知公告</el-menu-item> -->
                <el-menu-item index="/Guest/UserManagement">用户管理</el-menu-item>
                <el-menu-item index="/Formation/Inforamtion">会议资讯管理</el-menu-item>
              </el-menu>
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-menu
                class="el-menu-demo"
                background-color="#393D49"
                text-color="#fff"
                mode="horizontal"
              >
                <el-menu-item
                  class="no_hover"
                  v-show="login_name!=''"
                >欢迎：{{login_name}}</el-menu-item>
                <el-menu-item class="no_hover">
                  <span style="font-size: 12px;">{{checkjigou}}<span style="font-size: 12px;">—{{chechbumen}}</span></span>&nbsp;&nbsp;&nbsp;
                  <el-popover
                    placement="top-start"
                    width="200"
                    trigger="click"
                    v-model="visible"
                  >
                    <el-cascader
                      :options="options"
                      size="small"
                      clearable
                      :props="defaultParams"
                      v-model="optval"
                    >
                    </el-cascader>
                    <el-row class="okrow">
                      <el-button
                        size="small"
                        @click="aswitchingtrue"
                      >确定</el-button>
                      <el-button
                        size="small"
                        @click="aswitchingfalse"
                      >取消</el-button>
                    </el-row>
                    <el-button
                      type="text"
                      slot="reference"
                      size="small"
                      style="color:#E6A23C"
                    >切换机构</el-button>
                  </el-popover>
                </el-menu-item>
                <el-menu-item
                  class="no_hover"
                  v-show="token"
                >
                  <el-button
                    type="warning"
                    @click=" handleLogOut"
                    v-show="login_name!=''"
                    size="small"
                  >退出登录</el-button>
                </el-menu-item>
              </el-menu>
            </el-col>
          </el-col>
        </el-row>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  name: "top-navbar",
  computed: {
    routeName () {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    }
  },

  data () {
    return {
      defaultParams: {
        label: 'name',
        value: 'id',
        children: 'dep'
      },
      login_name: "",
      checkjigou: "",
      chechbumen: "",
      options: [],
      activeNotifications: false,
      // activeIndex: "/home/HomePage",
      token: true,
      dep_is_auth: "true",
      team: "true",
      visible: false,
      optval: []
    };
  },
  created () {
    // this.activeIndex = this.$route.path;
  },
  mounted () {
    var _this = this;
    _this.login_name = localStorage.getItem("name");
    var optarr = JSON.parse(localStorage.getItem("team"))
    _this.optval.push(Number(optarr.team_id))
    _this.optval.push(Number(optarr.dep_id))
    _this.checkjigou = optarr.team_name
    _this.chechbumen = optarr.dep_name
    _this.getmechanism()
  },
  methods: {
    /* 获取机构列表 */
    getmechanism () {
      var _this = this
      var url = _this.APIurl.API.api.listjigou
      _this.$get(url).then(res => {
        if (res.code == 1)
        {
          _this.options = res.posts
        }
      })
    },
    /* 切换机构确定 */
    aswitchingtrue () {
      var _this = this
      var url = _this.APIurl.API.api.changejigou
      var team = JSON.parse(localStorage.getItem("team"))
      _this.visible = false
      for (let i = 0; i < _this.options.length; i++)
      {
        if (_this.options[i].id == _this.optval[0])
        {
          _this.checkjigou = _this.options[i].name
          team.team_id = _this.options[i].id
          team.team_name = _this.options[i].name
          for (let j = 0; j < _this.options[i].dep.length; j++)
          {
            if (_this.options[i].dep[j].id == _this.optval[1])
            {
              _this.chechbumen = _this.options[i].dep[j].name
              team.dep_id = _this.options[i].dep[j].id
              team.dep_name = _this.options[i].dep[j].name
            }

          }
        }
      }
      var params = {
        team_id: _this.optval[0],
        dep_id: _this.optval[1]
      }
      _this.$post(url, params).then(res => {
        if (res.code == 1)
        {
          _this.$message({
            message: '机构切换成功',
            type: 'success',
            duration: 2000
          });
          localStorage.setItem("team", JSON.stringify(team));
          _this.$router.push("/home/HomePage")
        }
      })
    },
    /* 切换机构取消 */
    aswitchingfalse () {
      var _this = this
      _this.visible = false
    },
    handleChange (value) {
      console.log(value);
    },
    capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown () {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown () {
      this.activeNotifications = false;
    },
    toggleSidebar () {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar () {
      this.$sidebar.displaySidebar(false);
    },
    /* 推出登录 */
    handleLogOut () {
      var _this = this;
      _this.$confirm('是否要退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let url = "/member/logout";
        var params = {
          callbacktype: 'json'
        };
        _this.$post(url, params).then(res => {
          if (res.code == 1)
          {
            _this.$cookieStore.delCookie("member_info");
            _this.$cookieStore.delCookie("member_token");
            localStorage.removeItem("name");
            localStorage.removeItem("team");
            window.location.replace(res.url)
          }
        });
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消退出'
        });
      });

    }
  }
};
</script>
<style scoped>
.okrow {
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
}
.okrow button {
  background-color: #393d49;
  color: white;
}
.el-drawer:focus {
  outline: none;
}
.el-menu {
  border: 0;
}

.navbar span {
  color: white;
  font-size: 14px;
}
.navbar .navbar-nav .nav-item .nav-link {
  color: white;
  font-size: 13px;
}
.outLogin:hover {
  color: #1e9fff !important;
}
.navbar span:hover {
  color: white !important;
}
.act {
  color: #1e9fff !important;
}
.el-menu.el-menu--horizontal {
  border: 0;
}
.no_hover:hover {
  background-color: rgb(57, 61, 73) !important;
}
</style>
